import "./lib/utils.js";
import "./components/product-card.js";
import "./components/product-card-slider.js";
import "./components/quantity-input.js";
import "./frame.js";

(function initPlugJs() {

    "use strict";

    /* global PLUG */

    const globalComponents = [
        "Frame",
    ];

    const capitalize = function (str) {
        const arr = str.split("");
        arr[0] = arr[0].toUpperCase();
        return arr.join("");
    };

    const camelCase = function (str) {
        const sepRegex = /[-_ .]+/g;
        return str.split(sepRegex).map(function (val, i) {
            return (i > 0 ? capitalize(val) : val);
        }).join("");
    };

    function initializeGlobalComponents() {
        globalComponents.forEach(function (componentName) {
            if (PLUG[componentName] && typeof PLUG[componentName].init === "function") {
                PLUG[componentName].init();
            }
        });
    }

    function initializeTemplate() {
        const templateName = capitalize(
            camelCase(
                PLUG.template.replace("page.", "").replace("customers/", "")
            )
        );
        const templateModule = PLUG.import(templateName + "Template");
        if (templateModule && typeof templateModule.init === "function") {
            templateModule.init();
        } else {
            console.log("no template script detected");
        }
    }

    function initializeEvents() {
        const U = PLUG.import("Utils");
        const main = document.getElementById("MainContent");
        const eventTarget = main;
        PLUG.events = {
            mobileToDesktopResize: new Event("mobileToDesktopResize"),
            desktopToMobileResize: new Event("desktopToMobileResize"),
            windowResize: new Event("windowResize"),
            target: eventTarget
        };
        let isMobile = U.isMobile();
        let resizeTimer;
        window.addEventListener("resize", function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                eventTarget.dispatchEvent(PLUG.events.windowResize);
                let wasMobile = isMobile;
                isMobile = U.isMobile();
                if (wasMobile && !isMobile) {
                    eventTarget.dispatchEvent(PLUG.events.mobileToDesktopResize);
                } else if (!wasMobile && isMobile) {
                    eventTarget.dispatchEvent(PLUG.events.desktopToMobileResize);
                }
            }, 100);
        });
    }

    function performStoreSpecificTasks() {
        // When a customer places a pay-later order, the cart attributes are not removed
        // from the cart even though all of the items are. Since you are brought to the homepage
        // after placing an order, we remove all pay-later related attributes when the custoemr
        if (PLUG.template === "index" && PLUG.cartIsEmpty && PLUG.cartHasAttributes) {
            const U = PLUG.import("Utils");
            const requestData = { attributes: {} };
            PLUG.payLaterCartAttributes.forEach((attributeName) => {
                requestData.attributes[attributeName] = "";
            });
            U.makeXmlRequest({
                method: "POST",
                url: "/cart/update.js",
                headerData: { "Content-Type": "application/json" },
                requestBody: JSON.stringify(requestData)
            }, (data, err) => {
                if (err) throw err;
            });
        }
    }

    function init() {
        try {
            initializeEvents();
            initializeGlobalComponents();
            initializeTemplate();

            performStoreSpecificTasks();
        } catch (exception) {
            console.log("Initialization Error: ", exception);
        }
    }

// Initialize our modules once the DOM is ready.

    if (document.readyState === "complete") {
        init();
    } else {
        window.addEventListener("DOMContentLoaded", init);
    }

})();
